import type { Match } from '../types';

export type SelectedMatchDestination = '/match-lineup' | '/match-analysis' | null;

export const getSelectedMatchDestination = (
  status: Match['status'] | undefined,
  prepareRequested: boolean,
): SelectedMatchDestination => {
  if (status === 'completed') return '/match-analysis';
  if (prepareRequested) return '/match-lineup';
  return null;
};
